import { render, staticRenderFns } from "./SubtitlesConfig.vue?vue&type=template&id=c116835c&scoped=true"
import script from "./SubtitlesConfig.vue?vue&type=script&lang=js"
export * from "./SubtitlesConfig.vue?vue&type=script&lang=js"
import style0 from "./SubtitlesConfig.vue?vue&type=style&index=0&id=c116835c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c116835c",
  null
  
)

export default component.exports